import { brand as productBrand } from '@hrmydeck/design-tokens/ui';

/** hrmsea product fallback before /api/app-config loads. Override with VITE_PRODUCT_NAME. */
export const brand = {
  name: import.meta.env.VITE_PRODUCT_NAME?.trim() || productBrand.name,
  tagline: import.meta.env.VITE_PRODUCT_TAGLINE?.trim() || productBrand.tagline,
} as const;
